// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForecastSchema } from './v1/forecastSchema';
import { v1ForecastsCreateSchema } from './v1/forecasts/createSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createTaskPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createTaskHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Task created
 */
export const createTask201Schema = z.lazy(() => v1ForecastSchema);

/**
 * @description Unauthorized
 */
export const createTask401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Validation errors
 */
export const createTask422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createTaskMutationRequestSchema = z.lazy(() => v1ForecastsCreateSchema);

export const createTaskMutationResponseSchema = z.lazy(() => createTask201Schema);
